import React, {Component} from "react";
import "./LorList.scss"
import {Button, DatePicker, Layout, message, Table} from "antd";
import intl from "react-intl-universal";
import {Link} from "react-router-dom";

const {Header, Content,} = Layout;

class LorList extends Component {

    constructor(props) {
        super(props);
        this.state = {

            list: [],
            listColumns: [
                {title: intl.get('number'), dataIndex: 'id'},
                // {
                //     title: intl.get('device_time'), dataIndex: 'device_time',
                //     render: (device_time) => (
                //         <span>{device_time.replace('T', ' ')}</span>
                //     )
                // },
                {title: intl.get('plate_no'), dataIndex: 'plate_no'},
                {title: intl.get('car_type'), dataIndex: 'car_type',
                   render: (car_type) => (
                       <span>{this.returnCarType(car_type)}</span>
                    )},
                {
                    title: intl.get('car_type'), dataIndex: 'car',
                    render: (car) => (
                       <span>{this.returnType(car)}</span>
                    )
                },
                {
                    title: intl.get('operation'), key: 'actions',
                    render: ({id}) => (
                        <Link to={`/lordetail/${id}`}>{intl.get('view')}</Link>

                    ),
                },
            ],
            loading: false,
            pagination: {},
            from: "",
            to: "",
            rep_time: ''

        }
    };

    returnType(car){
        let result = intl.options.currentLocale=='zh'? car.zh:car.en;
        return result
    };

    // 返回类型
    returnCarType(type){
        switch (type) {
            case 'truck':
                return intl.get('truck');
            case 'mount':
                return intl.get('mount');
        }
    };

    componentDidMount() {
        this.getReports()
    }

    // 获取报告

    getReports(params = {page: 1,from: this.start, to: this.end,
        // device_time: this.rep_time
    }) {
        this.setState({loading: true});
        global.Api.getLorList({
            qs: '',
            ...params
        }).then(res => {
            if (res.data.code === 0) {
                const pagination = {...this.state.pagination};
                let _data = res.data.data;
                pagination.total = _data.total;
                pagination.pageSize = 15;
                this.setState({
                    loading: false,
                    list: _data.reports,
                    pagination,
                });
                return
            }
            message.error(res.data.message);

        })
    }

    //下载报告
    lorryReportsDownload = () => {
        global.Api.downloadLorryReports({
            // device_time:this.rep_time,
            from: this.start,
            to: this.end,
            lang:intl.options.currentLocale}).then(res =>{
            if (res.data.code === 0){
                let _data = res.data.data;
                window.location.href = _data.download_url;
            }
        })
    }

    // 翻页
    handleTableChange = (pagination) => {
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        this.getReports({
            page: pagination.current,
            per_page: pagination.pageSize,
            from: this.start,
            to: this.end,
            // device_time: this.rep_time
        });
    };

    //筛选
    select = (dates, dateStrings) =>{
        this.start = dateStrings[0]
        this.end = dateStrings[1]
        this.dateArr = dateStrings
        this.getReports()
    }
    // select = () =>{
    //     let select = document.getElementById('TimeId');
    //     this.rep_time = select.value
    //     console.log(this.rep_time);
    //     this.getReports()
    //
    // }

    render() {
        // 选择器
        // const  TimeSelect = () =>{
        //     return(
                // <select id="TimeId"  onChange={() => this.select()}  style={{color:"blue"}}>
                //     <option value='' >-{intl.get('time')}-</option>
                //     <option value="today">{intl.get('today')}</option>
                //     <option value="yesterday">{intl.get('yesterday')}</option>
                //     <option value="week">{intl.get('week')}</option>
                //     <option value="month">{intl.get('month')}</option>
                //     <option value="last_month">{intl.get('last_month')}</option>
                //     <option value="year">{intl.get('year')}</option>
                // </select>
            // )
        // }
        const { RangePicker } = DatePicker;
        return (
            <Layout className="lorlist">
                <Header style={{position: 'fixed', zIndex: 1, width: '100%', color: "#fff"}}>
                    {/*<TimeSelect />*/}
                    <RangePicker defaultValue={this.state.dateArr} format='YYYY-MM-DD' onChange={(dates,dateStrings) => this.select(dates, dateStrings)}/>
                    <a href="#" onClick={this.lorryReportsDownload} style={{marginLeft:"10px"}}>{intl.get('download')}</a>
                     <Button type="link" style={{marginRight:"150px"}} ><Link to="/reports">{intl.get('pass')}</Link></Button>
                </Header>
                <Content style={{padding: '0 50px', marginTop: 84}}>
                    <div style={{background: '#fff', padding: 24}}>
                        <Table
                            rowKey={item => item.id}
                            dataSource={this.state.list}
                            columns={this.state.listColumns}
                            pagination={this.state.pagination}
                            loading={this.state.loading}
                            onChange={this.handleTableChange}/>
                    </div>
                </Content>
            </Layout>
        )
    }

}

export default LorList